import { connect } from 'react-redux';
import { carouselPausedCreator, carouselUnpausedCreator } from '../../actions';
import {
  getCarouselSlideIndex,
  getCarouselSlide,
  getSliceIsEdgeToEdge,
  hasActiveCountdown as hasActiveCountdownSelector,
  getSliceTypography,
} from '../../selectors';
import Caption from './Caption';

const mapStateToProps = (state, { carouselId, slideIndex }) => {
  const {
    countdown_title: countdownTitle,
    ...content
  } = getCarouselSlide(state, carouselId, slideIndex);
  const hasActiveCountdown = hasActiveCountdownSelector(state, carouselId, slideIndex);
  const title = (hasActiveCountdown && countdownTitle && countdownTitle.text) || content.title;
  return {
    ...content,
    title,
    hasActiveCountdown,
    isCurrent: getCarouselSlideIndex(state, carouselId) === slideIndex,
    edgeToEdge: getSliceIsEdgeToEdge(state, carouselId),
    subtitle: content.subtitle,
    contentWidth: content.content_container_width,
    typography: getSliceTypography(state, carouselId),
  };
};

const mapDispatchToProps = (dispatch, { carouselId }) => ({
  onMouseEnter: () => dispatch(carouselPausedCreator(carouselId)),
  onMouseLeave: () => dispatch(carouselUnpausedCreator(carouselId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Caption);
